/* Package JSON Import will be here */
import React from "react";
import { Empty } from 'antd';
import Img from "react-image";
import classNames from "classnames";
/* Package JSON Import will be here */

/* Project Import will be here */
import noDataImage from "assets/img/no_data.png";
/* Project Import will be here */

const NoData = props => {
    const renderComp = () => {
        if (props.NeedSmallImg) {
            return (
                <Empty description={props.NoDataMessage} image={noDataImage} />
            );
        }
        return (
            <div justify="center"
                className={classNames('text-center', {
                    'mt-3': props.isFromSmallSection,
                    'mt-5': !props.isFromSmallSection
                })}
            >
                <Img className="noDate-img" src={noDataImage} alt="" />
                <p className="font-15 mt-2 color-black">{props.NoDataMessage}</p>
            </div>
        );
    }

    return (
        renderComp()
    );
};

export default NoData;